module.exports = __webpack_public_path__ + "img/left_top_huang.625500ce.png";